<template>
  <m-input-select
    :fullwidth="fullwidth"
    :label="label"
    :loading="casinosMeta.loading"
    :options="casinoOptions"
    :value="value"
    @input="handleCasinoSelect"
  />
</template>

<script>
  import { MInputSelect } from 'codefabrik-gui-vue'
  import { useCasinos } from '@/views/casinos/casinoHooks'

  export default {
    name: 'CasinoSelect',
    components: { MInputSelect },
    props: {
      value: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      fullwidth: Boolean,
      nullable: {
        type: Boolean,
        default: false
      },
    },
    mixins: [
      useCasinos('casinos'),
    ],
    computed: {
      nullOption () {
        return { value: null, label: this.placeholder }
      },
      casinoOptions () {
        const options = this.casinos.map(it => {
          return { value: it.id, label: it.name }
        })
        if (this.nullable) {
          return [this.nullOption, ...options]
        } else {
          if (this.value == null && options.length > 0) {
            this.handleCasinoSelect(options[0].value)
          }
          return options
        }
      },
    },
    methods: {
      handleCasinoSelect (newValue) {
        this.$emit('input', newValue)
      },
    },
  }
</script>

<style scoped>

</style>
